import { useFeatureGate } from '@ctct/awesome-feature-flags';
import type { PaymentMethodOptions } from '@ctct/domain-layer';
import { envs } from '@ctct/infrastructure-layer';

const resolvePaymentMethodOptions = (isEnabled: boolean): PaymentMethodOptions => ({
  usBankAccount: {
    verificationMethod: isEnabled ? 'AUTOMATIC' : 'INSTANT',
  },
});

export const useAchMicroDepositsGate = (): {
  data: PaymentMethodOptions;
  isEnabled: boolean;
  isLoading: boolean;
} => {
  if (envs.isSecure()) {
    // In secure, we don't have access to statsig, so we return a value based on the URL parameter.
    const isEnabledViaURLParam = new URLSearchParams(window.location.search).get('aff-amd') === 'true';

    return {
      data: resolvePaymentMethodOptions(isEnabledViaURLParam),
      isEnabled: isEnabledViaURLParam,
      isLoading: false,
    };
  }

  // hooks list will be stable per env, so we can safely disable the hooks rule
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const featureGate = useFeatureGate({
    name: 'enable_ach_microdeposits',
    defaultValue: false,
  });

  const isEnabled = featureGate?.data ?? false;

  return {
    data: resolvePaymentMethodOptions(isEnabled),
    isEnabled,
    isLoading: featureGate.isLoading,
  };
};
